import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { format, isValid, parse } from "date-fns";
import { InputAdornment } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { fieldSx } from "components/SideDrawer";

// MUI pickers that read/write the plain strings the finance API uses
// ("yyyy-MM-dd" and 24h "HH:mm"), so forms can keep string state.

const DATE_FORMAT = "yyyy-MM-dd";
const TIME_FORMAT = "HH:mm";

const toDate = (value: string, pattern: string) => {
  if (!value) return null;
  const d = parse(value, pattern, new Date());
  return isValid(d) ? d : null;
};

const toString = (d: Date | null, pattern: string) =>
  d && isValid(d) ? format(d, pattern) : "";

export const DateField = ({
  value,
  onChange,
  disableFuture,
  minDate,
}: {
  value: string;
  onChange: (value: string) => void;
  disableFuture?: boolean;
  minDate?: string;
}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <DatePicker
      value={toDate(value, DATE_FORMAT)}
      onChange={(d) => onChange(toString(d, DATE_FORMAT))}
      disableFuture={disableFuture}
      minDate={minDate ? toDate(minDate, DATE_FORMAT) ?? undefined : undefined}
      format="dd MMM yyyy"
      slotProps={{ textField: { fullWidth: true, size: "small", sx: fieldSx } }}
    />
  </LocalizationProvider>
);

export const TimeField = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <MobileTimePicker
      value={toDate(value, TIME_FORMAT)}
      // onChange fires on every hour/minute/AM-PM step inside the dialog;
      // commit only on OK so dependent queries (e.g. reschedule preview) run once.
      onAccept={(d) => onChange(toString(d, TIME_FORMAT))}
      format="hh:mm a"
      slotProps={{
        textField: {
          fullWidth: true,
          size: "small",
          sx: fieldSx,
          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                <AccessTimeIcon fontSize="small" sx={{ color: "#667085" }} />
              </InputAdornment>
            ),
          },
        },
      }}
    />
  </LocalizationProvider>
);
